// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"347":"9730f66e","453":"6159162a","490":"99432975","737":"7bd193f7","786":"0b8ff90c","799":"b936686b","907":"017aaeca"}[chunkId] + ".chunk.js";
};